<template>
  <section class="card border-0">
    <div class="card-body">
      <h6 class="mb-3">{{ title }}</h6>

      <div class="d-flex align-items-center mb-3">
        <span class="me-2 text-muted small">현재</span>
        <span class="text-dark px-3 py-2 small">
          {{ displayValue }}
        </span>
      </div>

      <input
        type="range"
        class="form-range fuel-slider"
        :min="innerMin"
        :max="innerMax"
        :step="step"
        :value="modelValueNumber"
        @input="onInput"
      />

      <div class="d-flex justify-content-between">
        <small class="text-muted">{{ innerMin }} {{ unit }}</small>
        <small class="text-muted">{{ innerMax }} {{ unit }}</small>
      </div>

      <label v-if="hint" class="text-muted small mt-3 mb-0">
        {{ hint }}
      </label>
    </div>
  </section>
</template>

<script>
export default {
  name: "FuelEfficiencySlider",
  props: {
    modelValue: { type: [Number, String], default: 0 },
    fuelType: { type: String, default: "DIESEL" }, // 연료 타입 받음
    title: { type: String, default: "연비" },
    hint: { type: String, default: "슬라이더로 값을 조절하세요." },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 50 },
    step: { type: Number, default: 0.1 },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      innerMin: this.min,
      innerMax: this.max,
    };
  },
  computed: {
    isElectric() {
      return this.fuelType === "ELECTRIC";
    },
    unit() {
      return this.isElectric ? "kWh/100km" : "km/L";
    },
    modelValueNumber() {
      const n = Number(this.modelValue ?? 0);
      return Number.isFinite(n) ? n : 0;
    },
    displayValue() {
      return this.isElectric
        ? `${this.modelValueNumber.toFixed(2)} kWh/100km`
        : `${this.modelValueNumber.toFixed(2)} km/L`;
    },
  },
  methods: {
    onInput(e) {
      const val = Number(e.target.value);
      const fixed = Number(val.toFixed(2));
      this.$emit("update:modelValue", fixed);
      this.$emit("change", fixed);
    },
  },
};
</script>
